export const getVideoUploaderStyles = isCurrentThemeLight => ({
  videoContainer: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column'
  },
  videoPlaceholder: {
    width: '100%',
    height: '100%',
    minHeight: '300px',
    display: 'flex',
    flexDirection: 'column',
    border: '1px solid',
    borderImageSource: isCurrentThemeLight
      ? 'linear-gradient(158.03deg, rgba(0, 0, 0, 0.1) 0%, rgba(0, 0, 0, 0.3) 50%, rgba(0, 0, 0, 0.1) 100%)'
      : 'linear-gradient(158.03deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.3) 50%, rgba(255, 255, 255, 0.1) 100%)',
    justifyContent: 'center',
    alignItems: 'center',
    background: isCurrentThemeLight ? 'rgba(0, 0, 0, 0.04)' : 'rgba(255, 255, 255, 0.1)',
    backdropFilter: 'blur(100px)',
    borderRadius: '16px',
    gap: '16px'
  },
  videoIcon: {
    width: '48px',
    height: '48px',
    color: isCurrentThemeLight ? 'rgba(0, 0, 0, 0.3)' : 'rgba(255, 255, 255, 0.7)'
  },
  maxSizeInfo: {
    fontFamily: 'DM Sans',
    fontWeight: 'lighter',
    fontSize: '14px',
    marginTop: '8px',
    color: isCurrentThemeLight ? 'rgba(0, 0, 0, 0.6)' : 'rgba(118, 118, 125, 1)'
  },
  errorText: {
    fontFamily: 'DM Sans',
    fontWeight: 'medium',
    fontSize: '14px',
    marginTop: '8px',
    color: '#d32f2f'
  },
  buttonContainer: {
    display: 'flex',
    gap: '12px',
    flexDirection: 'column',
    alignItems: 'center'
  },
  uploadButton: {
    textTransform: 'none',
    borderRadius: '12px',
    background: 'rgba(97, 35, 255, 1)',
    fontSize: '16px',
    color: 'rgba(255, 255, 255, 1)',
    fontFamily: 'DM Sans',
    padding: '8px 20px',
    minWidth: '140px',
    '&:hover': {
      background: 'rgba(87, 25, 235, 1)'
    }
  },

  videoPreview: {
    width: '100%',
    height: '100%',
    minHeight: '400px',
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'hidden',
    borderRadius: '12px',
    backgroundColor: 'rgba(0, 0, 0, 0.2)',
    boxSizing: 'border-box'
  },
  video: {
    width: '100%',
    height: '100%',
    objectFit: 'contain',
    borderRadius: '8px',
    display: 'block',
    backgroundColor: '#000'
  },
  loadingContainer: {
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#000',
    borderRadius: '8px'
  },
  deleteButton: {
    position: 'absolute',
    top: '8px',
    right: '8px',
    backgroundColor: 'rgba(255, 255, 255, 0.8)',
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.9)'
    }
  }
})

export const getTextVideoModuleStyles = () => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    height: '100%',
    overflow: 'hidden'
  },
  previewContainer: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    gap: '16px'
  },
  previewVideoContainer: {
    flex: 1,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    overflow: 'hidden',
    borderRadius: '12px',
    backgroundColor: 'rgba(0, 0, 0, 0.2)',
    boxSizing: 'border-box',
    position: 'relative',
    minHeight: '400px'
  },
  previewTitle: {
    fontFamily: 'Satoshi',
    fontSize: '32px',
    fontWeight: 900,
    color: 'rgba(255, 255, 255, 1)',
    wordBreak: 'break-word',
    marginBottom: '8px',
    flexShrink: 0
  },
  fieldContainer: {
    position: 'relative',
    width: '100%',
    flexShrink: 0
  },
  uploaderContainer: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    minHeight: '300px'
  },
  titleInput: {
    width: '100%',
    fontSize: '32px',
    fontWeight: 900,
    border: 'none',
    outline: 'none',
    resize: 'none',
    fontFamily: 'Satoshi',
    padding: 0,
    margin: 0,
    backgroundColor: 'transparent',
    wordBreak: 'break-word',
    whiteSpace: 'pre-wrap',
    minHeight: '40px',
    maxHeight: '80px'
  },
  alert: {
    width: '100%',
    marginBottom: '8px',
    flexShrink: 0
  }
})

export const getVideoViewerStyles = () => ({
  iframe: {
    width: '100%',
    height: '100%',
    borderRadius: '12px',
    border: 'none',
    backgroundColor: '#000'
  },
  video: {
    width: '100%',
    height: '100%',
    borderRadius: '12px',
    border: 'none',
    backgroundColor: '#000',
    objectFit: 'contain'
  },
  container: {
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#000',
    borderRadius: '12px',
    position: 'relative'
  },
  videoWrapper: {
    width: '100%',
    height: '100%',
    position: 'relative',
    backgroundColor: '#000',
    borderRadius: '12px',
    overflow: 'hidden',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  uniformVideo: {
    width: '100%',
    height: '100%',
    borderRadius: '12px',
    border: 'none',
    backgroundColor: '#000',
    objectFit: 'contain',
    outline: 'none',
    '&::-webkit-media-controls-panel': {
      backgroundColor: 'rgba(0, 0, 0, 0.8)'
    },
    '&::-webkit-media-controls-play-button': {
      backgroundColor: 'rgba(255, 255, 255, 0.1)',
      borderRadius: '50%'
    },
    '&::-webkit-media-controls-timeline': {
      backgroundColor: 'rgba(255, 255, 255, 0.2)'
    },
    '&::-webkit-media-controls-current-time-display': {
      color: '#fff'
    },
    '&::-webkit-media-controls-time-remaining-display': {
      color: '#fff'
    }
  },
  uniformIframe: {
    width: '100%',
    height: '100%',
    borderRadius: '12px',
    border: 'none',
    backgroundColor: '#000',
    outline: 'none'
  }
})
